import { composite as o } from "./highrise993.mjs";
function t(r) {
  return o(r, [255, 255, 255, 0.16]);
}
function n(r) {
  return o(r, [0, 0, 0, 0.12]);
}
export {
  t as createHoverColor,
  n as createPressedColor
};
